import Head from 'next/head'
import Link from 'next/link'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import configuration from '~/configuration'
import { Button } from '~/core/ui/Button'
import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import LPContainer from './LPContainer'

const AllFeaturesHeroSection: FC = () => {
  const { t, i18n } = useTranslation()

  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href="/img/feature/lp/hero-background.png"
        />
        <link
          rel="preload"
          as="image"
          href="/img/feature/lp/all-features-hero-mweb.png"
        />
        <link
          rel="preload"
          as="image"
          href="/img/feature/lp/all-features-hero-desk.png"
        />
      </Head>

      <div className="relative bg-white py-[64px] tablet:py-[120px]">
        <LPContainer className="flex tablet:flex-row flex-col items-center relative max-w-[1266px]">
          {/* Background */}
          <img
            src="/img/feature/lp/new/logo-background-big.png"
            alt="Background"
            className={cn(
              'absolute top-[30px] right-[100px] w-full h-[330px] object-contain z-0',
              'tablet:w-[712px] tablet:h-[476px] tablet:-top-[100px] tablet:-left-[295px]'
            )}
          />

          <div className="desktop:mb-0 mb-8 tablet:mr-[30px] tablet:w-[600px]">
            <span className="px-2 text-base uppercase rounded bg-purple-100 text-purple-800">
              {t('all_features:tag')}
            </span>
            <TypographyText className="leading-[52px] font-medium text-gray-900 text-[43px] tablet:text-[61px] tablet:leading-[61px] text-center tablet:text-left animate-fadeInUp mt-6">
              {t('all_features:title')}
            </TypographyText>
            <TypographyText className="mt-4 mb-8 text-gray-700 text-base font-normal text-center tablet:text-left animate-fadeInUp">
              {t('all_features:description')}
            </TypographyText>
            <div className="flex justify-center tablet:justify-start animate-fadeInUp">
              <Link
                href={configuration.path.contactRequest}
                locale={i18n?.language}>
                <Button size="xl" label={`${t('lp:request_demo')}`} />
              </Link>
            </div>
          </div>
          <div className="tablet:flex-1 w-full flex items-center">
            {/* Banner image */}
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/all-features-hero-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/all-features-hero-mweb.png"
              />
              <img
                alt="Hero banner"
                fetchPriority="high"
                className="ml-auto w-full"
              />
            </picture>
          </div>
        </LPContainer>
      </div>
    </>
  )
}

export default AllFeaturesHeroSection
